function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Radio, InputNumber, Alert, Button, Divider } from 'antd';
import { Container, Row, Col } from 'react-bootstrap';
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var VisioForm = function VisioForm(_ref) {
  var candidat = _ref.candidat,
    handler = _ref.handler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormProcessing = _useState2[0],
    setIsFormProcessing = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    axios.post(Common.baseApiUrl + 'processvisio', {
      binocular: values.binocular,
      leftsight: values.leftsight,
      rightsight: values.rightsight,
      colorseeing: values.colorseeing,
      blowtest: values.blowtest,
      conclusion: values.conclusion,
      aid: Common.currentUser.id,
      cid: candidat.id
    }).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage('Une erreur est survenue');
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "pad cool-radius",
      style: {
        background: '#FFDE08',
        padding: '10px'
      },
      children: /*#__PURE__*/_jsxs("p", {
        children: [/*#__PURE__*/_jsx("b", {
          children: "RNC : "
        }), candidat.rnc, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
          children: "Pr\xE9nom: "
        }), candidat.firstname, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
          children: "Nom: "
        }), candidat.lastname, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
          children: "T\xE9l\xE9phone: "
        }), candidat.mobile, /*#__PURE__*/_jsx("br", {})]
      })
    }), /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsx("br", {}), errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
        type: "error",
        message: errorMessage,
        showIcon: true
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h6", {
        children: "ACUITE VISUELLE DE LOIN"
      }), /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 4,
            md: 4,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "binocular",
              label: "binoculaire ?",
              rules: [{
                required: true,
                message: 'Champs obligatoire'
              }],
              children: /*#__PURE__*/_jsx(InputNumber, {
                addonAfter: "/10"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 4,
            md: 4,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "leftsight",
              label: "Oeil Gauche ?",
              rules: [{
                required: true,
                message: 'Champs obligatoire'
              }],
              children: /*#__PURE__*/_jsx(InputNumber, {
                addonAfter: "/10"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 4,
            md: 4,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "rightsight",
              label: "Oeil droit ?",
              rules: [{
                required: true,
                message: 'Champs obligatoire'
              }],
              children: /*#__PURE__*/_jsx(InputNumber, {
                addonAfter: "/10"
              })
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h6", {
        children: "VISION DES COULEURS"
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "colorseeing",
        rules: [{
          required: true,
          message: 'Champs obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Radio.Group, {
          optionType: "button",
          buttonStyle: "solid",
          options: [{
            label: 'VALIDE',
            value: 1
          }, {
            label: 'NON VALIDE',
            value: 0
          }]
        })
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h6", {
        children: "TESTE D'EBLOUISSEMENT"
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "blowtest",
        children: /*#__PURE__*/_jsx(Radio.Group, {
          optionType: "button",
          buttonStyle: "solid",
          options: [{
            label: 'VALIDE',
            value: 1
          }, {
            label: 'NON VALIDE',
            value: 0
          }]
        })
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h6", {
        children: "CHAMPS PERIPHERIQUE"
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "peripheral",
        children: /*#__PURE__*/_jsx(Radio.Group, {
          optionType: "button",
          buttonStyle: "solid",
          options: [{
            label: 'VALIDE',
            value: 1
          }, {
            label: 'NON VALIDE',
            value: 0
          }]
        })
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h6", {
        children: "CONCLUSION"
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "conclusion",
        rules: [{
          required: true,
          message: 'Champs obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Radio.Group, {
          optionType: "button",
          buttonStyle: "solid",
          options: [{
            label: 'APTE SANS CORRECTION',
            value: 1
          }, {
            label: 'APTE AVEC CORRECTION',
            value: 2
          }, {
            label: 'INAPTE',
            value: 0
          }]
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormProcessing,
          type: "primary",
          htmlType: "submit",
          children: "Sauvegarder"
        })
      }), /*#__PURE__*/_jsx(Divider, {})]
    })]
  });
};
export default VisioForm;